import styles from './SavedFilters.module.scss';

export const SavedFiltersEmptyState = () => (
  <section aria-labelledby='saved-filters-empty-title' className={styles.state}>
    <h2 className={styles.stateTitle} id='saved-filters-empty-title'>
      No saved filters yet
    </h2>
    <p className={styles.stateDescription}>
      You can save a filter after applying search criteria on the listings page.
    </p>
  </section>
);
